import { render, staticRenderFns } from "./RequestWorkTypeRequiredIcon.vue?vue&type=template&id=50965a58&"
import script from "./RequestWorkTypeRequiredIcon.vue?vue&type=script&lang=js&"
export * from "./RequestWorkTypeRequiredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
